import React from "react";
import { Modal, Box, SpaceBetween, Button } from "@amzn/awsui-components-console";

interface AlertModalProps {
  visible: boolean;
  content: React.ReactNode;
  header?: string;
  onDismiss: () => void;
}

export const AlertModal = (alertModalProps: AlertModalProps) => {
  return (
    <Modal
      onDismiss={alertModalProps.onDismiss}
      visible={alertModalProps.visible}
      footer={
        <Box float="right">
          <SpaceBetween direction="horizontal" size="xs">
            <Button variant="link" onClick={alertModalProps.onDismiss}>
              Cancel
            </Button>
          </SpaceBetween>
        </Box>
      }
      header={alertModalProps.header}
      data-testid="alert-modal"
    >
      {alertModalProps.content}
    </Modal>
  );
};
